import { Typography, Container, Card } from '@mui/material'
import { styled } from '@mui/material/styles'
import { Box, Drawer } from '@mui/material'

import Button from 'components/Button'

// Styled components for drawer styles
export const StyledDrawer = styled(Drawer)(({ theme }) => ({
    '& .MuiDrawer-paper': {
        backgroundColor: '#fbfbfd',

        '@media (max-width:768px)': {
            width: '100%',
        },
    },
}))

export const StyledRoleReceiver = styled(Box)(({ theme }) => ({
    backgroundColor: theme?.palette?.background?.paper,
    padding: '1.6rem 3.2rem',
    textTransform: 'uppercase',
    boxShadow: '0 0.4rem 1.7rem 0 rgba(0, 0, 0, 0.07)',
    '@media (max-width:768px)': {
        padding: '1.6rem 1.6rem',
    },
}))

export const StyledRoleReceiverDivider = styled(Box)(({ theme }) => ({
    height: '0.1rem',
    backgroundColor: '#d8d8dd;',
}))

export const StyledLineManagerContainer = styled(Box)(({ theme }) => ({
    background: theme?.palette?.background?.paper,
    width: '100%',
    borderTop: '0.1rem solid #d8d8dd',
    boxShadow: '0 0.4rem 1.7rem 0 rgba(0, 0, 0, 0.07)',
}))

export const StyledLineManager = styled(Box)(({ theme }) => ({
    background: theme?.palette?.background?.paper,
    padding: '2.4rem 3rem',
    maxWidth: '48rem',
    '@media (max-width:768px)': {
        padding: '1.2rem 1.6rem',
    },
}))

export const StyledBox = styled(Box)(({ theme }) => ({
    padding: '2.5rem 3rem',
    backgroundColor: '#fbfbfd',
    width: '100%',
    borderTop: '0.1rem solid #d8d8dd',
    boxShadow: '0 0.4rem 1.7rem 0 rgba(0, 0, 0, 0.07)',
    '@media (max-width:768px)': {
        padding: '2.5rem 1.6rem',
    },
}))

export const StyledFormContainer = styled(Box)(({ theme }) => ({
    display: 'flex',
    '@media (max-width:768px)': {
        flexDirection: 'column',
    },
}))

export const StyledRequestName = styled(Box)(({ theme }) => ({
    flex: 0.75,
    paddingRight: '0.8rem',
    '@media (max-width:768px)': {
        paddingRight: 0,
    },
}))

export const StyledDueDate = styled(Box)(({ theme }) => ({
    flex: 0.25,
    paddingLeft: '0.8rem',
    '@media (max-width:768px)': {
        paddingLeft: 0,
        maxWidth: '20rem',
    },
}))

export const StyledCartComment = styled(Box)(({ theme }) => ({
    marginTop: '-0.8rem',
    flex: 0.75,
    '@media (max-width:768px)': {
        flexDirection: 'column',
        marginTop: '2.4rem',
    },
}))

export const StyledCartItem = styled(Card)(({ theme }) => ({
    margin: '3.6rem 0',
    position: 'relative',
    overflow: 'visible',
    borderRadius: '0.8rem !important',
    boxShadow: '0 0.4rem 1.6rem 0 rgba(0, 0, 0, 0.05) !important',
}))

export const StyledBorderBox = styled(Box)(({ theme }) => ({
    borderImageSource:
        'linear-gradient(to right, rgba(1, 174, 143, 0), #04ab93 7%, #2c83bd 91%, rgba(48, 127, 193, 0)) !important',
    borderImageSlice: `${1} !important`,
    borderBottom: '0.1rem solid !important',
    opacity: '0.25',
}))

export const StyledRiskBorderBox = styled(Box)(({ theme }) => ({
    borderImageSource:
        'linear-gradient(to right, rgba(208, 2, 27, 0), #d0021b 8%, #d00238 91%, rgba(208, 2, 69, 0)) !important',
    borderImageSlice: `${1} !important`,
    borderBottom: '0.1rem solid !important',
    opacity: '0.25',
}))

export const StyledCartItemHeader = styled(Box)(({ theme, bgColor }) => ({
    background: bgColor,
    padding: '1.6rem',
    position: 'relative',
    borderTopLeftRadius: '0.8rem',
    borderTopRightRadius: '0.8rem',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    '& svg.delete': {
        color: theme?.palette?.error?.main,
    },
}))

export const StyledDeleteIconContainer = styled(Box)(({ theme }) => ({
    backgroundColor: '#faf7f6',
    borderRadius: '0.8rem',
    height: '3.2rem',
    width: '3.2rem',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    '&:hover': {
        cursor: 'pointer',
        backgroundColor: '#d8d8dd',
    },
}))

export const StyledItemLabel = styled(Box)(({ theme }) => ({
    position: 'absolute',
    top: '-1.4rem',
    display: 'flex',
    '@media (max-width:768px)': {
        left: '-0.8rem',
    },
}))

export const StyledAddOrRemoveLabel = styled(Box)(
    ({ theme, assignmentType }) => ({
        backgroundImage:
            assignmentType === 'Add'
                ? 'linear-gradient(101deg, ' +
                  theme?.palette?.secondary?.main +
                  ', #30c17c)'
                : 'linear-gradient(102deg, #ae0142, #c14830)',
        borderRadius: '0.5rem',
        padding: '0.2rem 0.8rem',
        textTransform: 'uppercase',
        color: theme?.palette?.common?.white,
        fontSize: '1.2rem',
        fontWeight: 500,
        display: 'flex',
        alignItems: 'center',
    }),
)

export const StyledResourceTypeLabel = styled(Box)(({ theme }) => ({
    marginLeft: '2rem',
    backgroundColor: theme?.palette?.background?.paper,
    borderRadius: '0.5rem',
    border: '0.1rem solid #aab0b4',
    padding: '0.2rem 0.8rem',
    textTransform: 'uppercase',
    color: '#3b454d',
    fontSize: '1.2rem',
    fontWeight: 600,
    display: 'flex',
    alignItems: 'center',
}))

export const StyledCartItemContent = styled(Box)(({ theme }) => ({
    padding: '1.6rem 1.6rem',
}))

export const StyledCartCommentContainer = styled(Box)(({ theme }) => ({
    display: 'flex',
    marginBottom: '1rem',
    '@media (max-width:660px)': {
        flexDirection: 'column',
    },
}))

export const StyledCartCommentField = styled(Box)(({ theme }) => ({
    flex: 0.75,
    marginTop: '-0.8rem',
}))

export const StyledTimeConstraints = styled(Box)(({ theme }) => ({
    flex: 0.25,
    marginLeft: '1.6rem',
    marginRight: '1.6rem',
    '@media (max-width:660px)': {
        marginLeft: 0,
        marginRight: 0,
    },
}))

export const StyledMoreAttributes = styled(Box)(({ theme }) => ({
    '@media (max-width:660px)': {
        marginTop: '0.8rem',
    },
}))

export const StyledHorizontalOrVertical = styled(Box)(({ theme }) => ({
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    '& > div:last-child': {
        marginLeft: '1.6rem',
    },
    '@media (max-width:660px)': {
        flexDirection: 'column',
        alignItems: 'flex-start',
        justifyContent: 'flex-start',
        '& > div:last-child': {
            marginLeft: 0,
        },
    },
}))

export const StyledAdditionalField = styled(Box)(({ theme }) => ({
    display: 'flex',
    flexDirection: 'column',
}))

export const StyledAdditionalFieldWrapper = styled(Box)(({ theme }) => ({
    padding: '0 1.6rem',
}))

export const StyledFieldHeaderTitle = styled(Box)(({ theme }) => ({
    background:
        'repeating-linear-gradient(#fff, #fff 3px, rgba(0, 0, 0, 0.02) 3px, rgba(0, 0, 0, 0.02) 4px)',
    display: 'flex',
    justifyContent: 'space-between',
    borderBottom: '0.1rem solid #efeff1',
    padding: '0 1.6rem',
}))

export const StyledExpandButton = styled(Box)(({ theme }) => ({
    textTransform: 'uppercase',
    zIndex: 9999,
    marginTop: '0.2rem',
    color: '#307fc1',
    fontSize: '1.2rem',
    '&:hover': {
        cursor: 'pointer',
    },
}))

export const StyledExpandIcon = styled(Box)(({ theme }) => ({
    width: '1.8rem',
    height: '1.8rem',
    marginLeft: '0.8rem',
    marginTop: '-0.2rem',
    borderRadius: '50%',
    border: `0.1rem solid ${theme?.palette?.primary?.main}`,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    color: theme?.palette?.primary?.main,
    lineHeight: '0',
    fontSize: '1.5rem',
}))

export const StyledCartItemContentWithFieldTypes = styled(Box)(({ theme }) => ({
    paddingBottom: '0 !important',
    paddingLeft: '0 !important',
    paddingRight: '0 !important',
}))

export const StyledCartCommentContainerFieldType = styled(Box)(({ theme }) => ({
    padding: '0 1.6rem !important',
}))

export const StyledFieldTypeAttribute = styled(Box)(({ theme }) => ({
    '& div': {
        fontSize: '1.4rem',
        fontWeight: '600',
        color: theme?.palette?.common?.black,
    },
}))

export const StyledDarkBg = styled(Box)(({ theme }) => ({
    marginLeft: '-1rem',
    background: '#3b454d',
    color: theme?.palette?.common?.white,
    borderColor: '#3b454d',
    zIndex: '9',
    paddingLeft: '2rem',
}))

export const MyContainer = styled(Container)(({ theme }) => ({
    backgroundColor: '#fbfbfd',
    padding: '0.8rem 3.2rem !important',
    '@media (max-width:768px)': {
        padding: '0.8rem 1.6rem',
    },
}))

// MyTypography component
export const MyTypography = styled(Typography)(({ theme }) => ({
    overflowWrap: 'anywhere',
    '&.MuiTypography-h1': {
        color: theme?.palette?.common?.black,
        fontSize: '2.4rem',
        padding: '1.4rem 3rem 0.9rem 3rem',
        fontWeight: 'normal',
    },
    '&.MuiTypography-h2': {
        fontSize: '5rem',
        '& span': {
            width: '33rem',
            display: 'inline-block',
        },
        '& b': {
            fontWeight: '700',
        },
    },
    '&.MuiTypography-h3': {
        fontSize: '1.8rem',
        fontWeight: '500',
        color: theme?.palette?.common?.white,
    },
    '&.MuiTypography-h5': {
        fontSize: '3rem',
    },
    '&.MuiTypography-caption': {
        fontSize: '1.6rem',
        fontWeight: 'normal',
        color: '#8a8989',
    },
}))

export const StyledShowMoreButton = styled(Button)(({ theme }) => ({
    position: 'absolute',
    bottom: '0',
    right: '0.5rem',
    minWidth: '12rem',
    minHeight: '3.2rem',
    backgroundColor: theme?.palette?.background?.paper,
    boxShadow: '0 0.2rem 1.6rem 0 rgba(0, 0, 0, 0.11)',
    color: theme?.palette?.primary?.main,
    textTransform: 'uppercase !important',
    borderRadius: '1.6rem',
    fontSize: '1.1rem',
    lineHeight: '1.45',
    '&:hover': {
        backgroundColor: theme?.palette?.background?.paper,
        color: theme?.palette?.primary?.main,
        '& span': {
            color: theme?.palette?.primary?.main,
        },
    },
}))
